<template>
  <div
    ref="dynamicDiv"
    class="relative overflow-y-auto shrink no-scrollbar
          h-[calc(100vh-var(--startpoint)-0.5rem)] sm:h-[calc(100vh-var(--startpoint)-1rem)] 
          max-h-[calc(100vh-var(--startpoint)-0.5rem)] sm:max-h-[calc(100vh-var(--startpoint)-1rem)] 
          rounded-b-lg
          text-skin-b-list-base       
          bg-transparent"    
  >
    <slot></slot>
  </div>
</template>

<script>

export default {
  props: {
    other: {
      type: Boolean,
      default: false,
    },
  },
  name: 'DynamicDiv',
  data() {
    return {
      dynamicDiv: null,
    };
  },
  methods: {
    updateStartPoint() {
      if (this.dynamicDiv) {
        const startPoint = this.dynamicDiv.getBoundingClientRect().top + window.scrollY;
        this.dynamicDiv.style.setProperty('--startpoint', `${startPoint}px`);
      }
    },
  },
  mounted() {
    this.dynamicDiv = this.$refs.dynamicDiv;
    this.updateStartPoint();
    window.addEventListener('resize', this.updateStartPoint);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateStartPoint);
  },
};
</script>

<style scoped>
</style>
